import { ReactNode } from 'react';

import AttachMoneyIcon from '@mui/icons-material/AttachMoney';

import { TotalizerCard, TotalizerCardShell } from './TotalizerCard';

interface FicFidcEquityTotalizerProps {
  isLoading: boolean;
  value: ReactNode;
  complement: string;
}

export function FicFidcEquityTotalizer({
  isLoading,
  value,
  complement,
}: FicFidcEquityTotalizerProps) {
  return (
    <TotalizerCard
      ariaLabel="Totalizador de PL do FIC pai"
      complement={complement}
      icon={
        <AttachMoneyIcon
          color="primary"
          aria-hidden
          data-testid="fic-fidc-equity-icon"
        />
      }
      isLoading={isLoading}
      label="PL do FIC pai"
      totalizerId="fic-fidc-equity-totalizer"
      value={value}
    />
  );
}

export function FicFidcEquityCard(props: FicFidcEquityTotalizerProps) {
  return (
    <TotalizerCardShell accent="primary" cardId="fic-fidc-equity-card">
      <FicFidcEquityTotalizer {...props} />
    </TotalizerCardShell>
  );
}
